var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 61,
    viewBox: "0 0 69 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666626 19.4782L31.8718 0.773695C33.5928 -0.257898 35.741 -0.257898 37.4615 0.773695L68.6666 19.4782V49.9638L0.666626 46.5504V19.4782Z",
    fill: "#0092C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.813 5.97058H6.51965V54.6789H62.813V5.97058Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6661 19.3939V60.1539H0.666626V19.3939L34.6664 39.7745L68.6661 19.3939Z",
    fill: "#D0ECF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.666626 60.1539L31.8122 37.7972C33.5184 36.5723 35.8143 36.5723 37.5205 37.7972L68.6661 60.1539H0.666626Z",
    fill: "#A0DDE4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6329 18.996H16.5801C16.2163 18.996 15.9186 18.5685 15.9186 18.0462C15.9186 17.5238 16.2163 17.0964 16.5801 17.0964H41.6329C41.9967 17.0964 42.2944 17.5238 42.2944 18.0462C42.2944 18.5685 41.9967 18.996 41.6329 18.996Z",
    fill: "#A0DDE4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9058 22.7952H16.6035C16.2268 22.7952 15.9186 22.3677 15.9186 21.8454C15.9186 21.323 16.2268 20.8956 16.6035 20.8956H55.9065C56.2832 20.8956 56.5915 21.323 56.5915 21.8454C56.5908 22.3677 56.2825 22.7952 55.9058 22.7952Z",
    fill: "#A0DDE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/Envelope.c2d262dbd5e3c96238812c254de0474e.svg";
export { ForwardRef as ReactComponent };